import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 9.26465C5 5.39465 8.13 2.26465 12 2.26465C15.87 2.26465 19 5.39465 19 9.26465C19 13.4346 14.58 19.1846 12.77 21.3746C12.37 21.8546 11.64 21.8546 11.24 21.3746C9.42 19.1846 5 13.4346 5 9.26465ZM9.49988 9.26465C9.49988 10.6446 10.6199 11.7646 11.9999 11.7646C13.3799 11.7646 14.4999 10.6446 14.4999 9.26465C14.4999 7.88465 13.3799 6.76465 11.9999 6.76465C10.6199 6.76465 9.49988 7.88465 9.49988 9.26465Z",
		fill: "currentColor"
	})
});
export default SvgLocationPin;
